export default "__VITE_ASSET__BVXeKmd7__"